module.exports = __webpack_public_path__ + "img/dropdown-menu-product-1-1.d6c99811.png";